import type { Environment } from 'src/types/types';

// @ts-expect-error Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
const getGraphqlEndpoint = (): string => global.GRAPHQL_ENDPOINT ?? '';

export const getOverridedCandidateGraphEndpoint = (
  environment: Environment,
): string | undefined => {
  const PROD_INT_CLOUD_URL =
    'http://candidate-graphql.int-cloud.seek.com.au/graphql';

  const STAGING_INT_CLOUD_URL =
    'http://candidate-graphql.staging.int-cloud.seek.com.au/graphql';

  switch (environment) {
    case 'development': {
      // GRAPHQL_ENDPOINT is set via .env.start.<configuration> files
      // (see .env.start.mock, .env.start.staging) and exposed via webpack DefinePlugin.
      // Falls back to mock-api on localhost:4000 when not set.
      //
      // For specialty endpoints (e.g. dark prod), set GRAPHQL_ENDPOINT directly:
      //   GRAPHQL_ENDPOINT=https://candidate-graphql-dark-prod.cloud.seek.com.au/graphql?branch=my-branch
      return getGraphqlEndpoint() || 'http://localhost:4000/graphql';
    }

    case 'production':
      return typeof window === 'undefined' ? PROD_INT_CLOUD_URL : undefined;

    case 'staging':
      return typeof window === 'undefined' ? STAGING_INT_CLOUD_URL : undefined;

    default:
      throw new Error(`Unknown environment: ${environment}`);
  }
};
